export const recurringDonationCard = () => {
  const cards = [
    ...document.querySelectorAll("[data-wm-recurring-donation-card]"),
  ];

  if (cards.length === 0) {
    return;
  }

  const renderMessage = (event) => {
    const cardId = event.detail.formId;

    document.querySelector(
      `[data-wm-recurring-donation-card="${cardId}"]`
    ).hidden = true;

    if (
      cards.length ===
      document.querySelectorAll("[data-wm-recurring-donation-card][hidden]")
        .length
    ) {
      document.querySelector(
        "[data-wm-no-recurring-donation-card]"
      ).hidden = false;
    }
  };

  document.addEventListener(
    "wm-cancelRecurringDonation::cancelled",
    renderMessage
  );
};
